import PathMatrix from "csi/table/matrix/Path";
import declare from "dojo/_base/declare";
import { pathCreate } from "csi/utility/pathUtility";
import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import locale from "csi/locale";
import ColorSizeAvailabilty from "./ColorSizeAvailability";

const ColorSizeAvailabilityMatrix = declare(PathMatrix, {
	columnPath: pathCreate("AvailabilityProduct", "ProductSizes"),

	/**
	 * @override
	 * Add availability column if there are any sizes
	 */
	getColumnSpecs(ctx: Context, h: Heading): Spec[] {
		const availabilityView = ctx.view as ColorSizeAvailabilty;
		const specs = availabilityView.bSizesOnly ? [] : this.inherited<Spec[]>(arguments);

		specs.unshift(new Spec({
			heading: h,
			headerParams: {
				innerText: locale.resource("Availability"),
			},
		}));

		return specs;
	},
});

export = ColorSizeAvailabilityMatrix;
